import { render, staticRenderFns } from "./Brand.vue?vue&type=template&id=754e24ff&scoped=true"
var script = {}
import style0 from "./Brand.vue?vue&type=style&index=0&id=754e24ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754e24ff",
  null
  
)

export default component.exports